/**
 * Basic accordion: `.accordion` with `.accordion__toggle` / `.accordion__content`.
 * - Only one item open at a time.
 * - Open / close uses height animation.
 */
function initAccordion(root = document) {
  const DURATION_MS = 220;
  const EASING = "ease";

  function stopAnimation(panel) {
    if (panel._accordionAnimation) {
      panel._accordionAnimation.cancel();
      panel._accordionAnimation = null;
    }
  }

  function animateHeight(panel, from, to, onDone) {
    stopAnimation(panel);

    if (!panel.animate) {
      onDone();
      return;
    }

    panel._accordionAnimation = panel.animate(
      [{ height: `${from}px` }, { height: `${to}px` }],
      { duration: DURATION_MS, easing: EASING },
    );

    panel._accordionAnimation.onfinish = () => {
      panel._accordionAnimation = null;
      onDone();
    };
    panel._accordionAnimation.oncancel = () => {
      panel._accordionAnimation = null;
    };
  }

  function openPanel(toggle, panel) {
    toggle.setAttribute("aria-expanded", "true");
    panel.hidden = false;
    panel.style.overflow = "hidden";
    panel.style.height = "0px";

    const targetHeight = panel.scrollHeight;
    animateHeight(panel, 0, targetHeight, () => {
      panel.style.height = "";
      panel.style.overflow = "";
    });
  }

  function closePanel(toggle, panel) {
    toggle.setAttribute("aria-expanded", "false");
    panel.style.overflow = "hidden";

    const startHeight = panel.offsetHeight;
    if (startHeight <= 0) {
      panel.hidden = true;
      panel.style.height = "";
      panel.style.overflow = "";
      return;
    }

    panel.style.height = `${startHeight}px`;
    animateHeight(panel, startHeight, 0, () => {
      panel.hidden = true;
      panel.style.height = "";
      panel.style.overflow = "";
    });
  }

  root.querySelectorAll(".accordion").forEach((accordion) => {
    accordion.addEventListener("click", (event) => {
      const toggle = event.target.closest(".accordion__toggle");
      if (!toggle || !accordion.contains(toggle)) {
        return;
      }

      const panelId = toggle.getAttribute("aria-controls");
      const panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) {
        return;
      }

      const wasOpen = toggle.getAttribute("aria-expanded") === "true";

      // Single-open accordion: close all other open items first.
      accordion
        .querySelectorAll(".accordion__toggle[aria-expanded='true']")
        .forEach((otherToggle) => {
          if (otherToggle === toggle) {
            return;
          }
          const otherPanelId = otherToggle.getAttribute("aria-controls");
          const otherPanel = otherPanelId
            ? document.getElementById(otherPanelId)
            : null;
          if (otherPanel) {
            closePanel(otherToggle, otherPanel);
          }
        });

      if (wasOpen) {
        closePanel(toggle, panel);
      } else {
        openPanel(toggle, panel);
      }
    });
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => initAccordion());
} else {
  initAccordion();
}
